module.exports = __webpack_public_path__ + "static/img/IMG_20160821_195541-COLLAGE.811cbb37.jpg";